module.exports = fox => {
	require('./stylus/_style.styl');

	require('fox-dynamic-injection!fox-template-loader!./templates/liveshow-templates.tpl')(fox);

	const require__js = require.context('./widget', false, /\.js$/);
	require__js.keys().forEach(md => require__js(md)(fox));

	fox.registerOptions('@root', {
		'widgets.liveshowNotificationBanner.widget': 'LiveshowNotificationBanner'
	}, true, {});

	fox.registerOptions('~.Layout_Home #notification', {
		externalHandler: (resp) => {
			if ((resp.message || '').match(/Live\sShow/) !== null) {
				fox.site.rwom1('#liveshowNotificationBanner').show();

				return false;
			}

			return true;
		}
	}, true, {});
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/liveshow/index.es.js